/**
 * Start the hearing worker (hearing.worker.ts) — the build decides how it is loaded, nothing else does.
 *
 * A CLASSIC worker everywhere (vite.config.ts `worker.format: 'iife'`): Chrome 68 (webOS, older Android TV
 * WebViews) has no module workers. The packaged Tizen build (VITE_PACKAGED) runs from file://, where a Worker
 * cannot be loaded by URL at all, so there the worker is inlined into the bundle and started from a blob:
 * URL — the same rule src/publicUrl.ts applies to the public/ scripts. Each branch is a static import the
 * build resolves; the other one is dead code there and dropped.
 */
export async function startHearingWorker(): Promise<Worker> {
  const { default: HearingWorker } = import.meta.env.VITE_PACKAGED === '1'
    ? await import('./hearing.worker.ts?worker&inline')
    : await import('./hearing.worker.ts?worker')
  return new HearingWorker()
}
